module.exports = __webpack_public_path__ + "static/alexwork1-e6e84cc0aad21065e952c21cdbc132ab.jpg";